import script from "./u_c_P7GW32.vue?vue&type=script&setup=true&lang=js"
export * from "./u_c_P7GW32.vue?vue&type=script&setup=true&lang=js"

import "./u_c_P7GW32.vue?vue&type=style&index=0&id=435d0feb&lang=scss&scoped=true"

import exportComponent from "/www/auto.37games.com/@mono/buildSpace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-435d0feb"]])

export default __exports__